if(typeof BSS_B2B != undefined) {
  setTimeout(() =>{
    const targetCart = document.querySelector("#bls-header_minicart");
    if (targetCart) {
      const mutationObserver = new MutationObserver((recordList, observe) => {
          BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),false,false);
          BSS_B2B.handleCartCheckoutBtn(JSON.parse($("#bss-b2b-store-data").html()));
      });
      mutationObserver.observe(targetCart, { attributes: true });
    }
  }, 1000)
}